import Link from "next/link";
import type { ResolvedLink } from "@/utils/header-navigation";

export default function NavigationLink({
  link,
  className,
  current,
  onClick,
  children,
  ...rest
}: {
  link: ResolvedLink;
  className?: string;
  current?: boolean;
  onClick?: () => void;
  children: React.ReactNode;
  "aria-label"?: string;
  style?: React.CSSProperties;
  "data-mobile"?: string;
  "data-menu-scope"?: string;
  "data-menu-role"?: string;
  "data-menu-item"?: string;
  "data-menu-surface"?: string;
}) {
  const props = {
    ...rest,
    className,
    onClick,
    target: link.newTab ? "_blank" : undefined,
    rel: link.newTab ? "noopener noreferrer" : undefined,
    "aria-current": current ? ("page" as const) : undefined,
  };
  return link.external ? (
    <a href={link.href} {...props}>
      {children}
    </a>
  ) : (
    <Link href={link.href} {...props}>
      {children}
    </Link>
  );
}
